// extracted by css-extract-rspack-plugin
export default {"cell-container":"cell-container-nGyLcj","cellContainer":"cell-container-nGyLcj"};